import React from 'react';
import {gql, useQuery} from "@apollo/client/index";

const SEND_REQUEST = gql`
  query($sn:String, $code:String) {
        applyDiscountCode(sn:$sn, code:$code) {
            message
        }
  }
`;

export default function ApplyCodeRequest(props) {

    const { error, data } = useQuery(
        SEND_REQUEST, {
            variables: {
                sn: props.sn,
                code: props.code
            }
        }
    );

    if (error) {
        props.onError(error);
    }

    if (data) {
        props.onData(data.applyDiscountCode);
    }

    return null;
}
